var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{on:{"ok":_vm.handleOk},model:{value:(_vm.showUpdateBanner),callback:function ($$v) {_vm.showUpdateBanner=$$v},expression:"showUpdateBanner"}},[_vm._v(" You need to update banner now ! ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }